import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { ToggleButton } from '@/shared/ui';

type ToggleInputOption = {
  label?: string;
  value?: string | number;
};

export type ToggleInputProps = {
  className?: string;
  name?: string;
  label?: string;
  disabled?: boolean;
  options: ToggleInputOption[];
  value: string | number;
  onChange: (name: string | undefined, value: string | boolean | number | undefined) => void;
  isError?: boolean;
  errorMessage?: string;
  // used in JSX below but never declared in the original PropTypes
  disabledIndexes?: number[];
};

const ToggleInput = ({
  className = '',
  name = '',
  label = '',
  disabled = false,
  isError = false,
  errorMessage = '',
  options,
  value,
  onChange,
  disabledIndexes,
}: ToggleInputProps) => {
  /**
   * Relays a toggle switch flip to the parent form. Forwards the field name and the new value to the onChange prop unchanged.
   *
   * @param name - Name of the toggle field.
   * @param value - The toggle's new value.
   * @returns Nothing.
   */
  const handleChange = (name: string | undefined, value: string | boolean | number | undefined) => {
    onChange(name, value);
  };

  return (
    <div className={classnames('custom-toggle-input', className)}>
      {!!label && <div className="custom-toggle-input__title">{label}</div>}

      <div className="flex">
        {_.map(options, (item, index) => (
          <ToggleButton
            key={index}
            className={classnames(
              'custom-toggle-input__list-item',
              disabled || _.includes(disabledIndexes, index) ? '--disabled' : '',
            )}
            name={name}
            data={item}
            isActive={item.value === value}
            onClick={handleChange}
            disabled={disabled || _.includes(disabledIndexes, index)}
          />
        ))}
      </div>
      {isError && !!errorMessage && (
        <div className="custom-toggle-input__error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default ToggleInput;
